export class Address {
  street: string;
  city: string;
  postal: string;
  country: string;
  countryCode: string;
  region: string;
  formattedAddress: string;
  location?: [number, number];
}
